import { render, staticRenderFns } from "./StrCatalogAutocomplete.vue?vue&type=template&id=47954440&"
import script from "./StrCatalogAutocomplete.vue?vue&type=script&lang=js&"
export * from "./StrCatalogAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports